import { markSpecs as e } from "./specs/mark-specs.js";
import { nodeSpecs as t } from "./specs/node-specs.js";
import { Schema as n } from "prosemirror-model";
//#region src/schema-generator.ts
var r = class {
	config;
	constructor(e) {
		this.config = e;
	}
	schema() {
		if (this.containsMultipleListTypes()) throw Error("schema should not have both nested and non-nested lists");
		return new n(this.schemaSpec);
	}
	containsMultipleListTypes() {
		let e = this.config.allowedBlocks, t = e.some((e) => this.isListType(e)), n = e.some((e) => this.isNestedListType(e));
		return t && n;
	}
	get schemaSpec() {
		return {
			nodes: this.nodes,
			marks: this.marks
		};
	}
	get nodes() {
		let e = {
			doc: t.doc,
			text: t.text,
			hardBreak: t.hardBreak,
			marker: t.marker
		};
		this.config.singleBlockMode && (e.doc = t.singleBlockDoc), this.config.templating && (e.template = t.template, e.template.infoResolver = this.config.templating.resolver), this.config.aiPromptData && (e.aiPromptData = t.aiPromptData, e.aiPromptData.infoResolver = this.config.aiPromptData.resolver, e.aiPromptData.commandsResolver = this.config.aiPromptData.commandsResolver), this.config.allowedBlocks.forEach((n) => {
			this.isListType(n) && !e.listItem ? e.listItem = t.listItem : n === "table" ? (e.tableRow = t.tableRow, e.tableCell = t.tableCell, this.config.tables.containers && (e.tableCell = {
				...e.tableCell,
				content: "(block | list | table)+"
			})) : this.isNestedListType(n) ? e.nestedListItem = t.nestedListItem : n === "collapsibleSection" ? (e.collapsibleSectionSummary = t.collapsibleSectionSummary, e.collapsibleSectionContent = t.collapsibleSectionContent) : n === "imageText" && (e.imageText = t.imageText), e[n] = t[n];
		}), this.config.allowedInline.forEach((n) => {
			t[n] && (e[n] = t[n]);
		});
		for (let t of this.config.customBlockHandlers ?? []) e[t.type] = t.spec;
		for (let t of this.config.customInlineHandlers ?? []) e[t.name] = t.spec;
		return this.config.fallbackBlockConfig && (e[this.config.fallbackBlockConfig.nodeTypeName] = this.config.fallbackBlockConfig.spec), this.stripListIfNeeded(e), this.stripTableIfNeeded(e), e;
	}
	stripListIfNeeded(e) {
		if (e.orderedList || e.unorderedList || e.orderedNestedList || e.unorderedNestedList) return;
		let t = (e.doc.content ?? "").replace(/list\s*\|\s*/, "").replace(/\s*\|\s*list/, "");
		e.doc = {
			...e.doc,
			content: t
		};
	}
	stripTableIfNeeded(e) {
		if (e.table) return;
		let t = (e.doc.content ?? "").replace(/table\s*\|\s*/, "").replace(/\s*\|\s*table/, "");
		e.doc = {
			...e.doc,
			content: t
		};
	}
	isListType(e) {
		return e === "orderedList" || e === "unorderedList";
	}
	isNestedListType(e) {
		return e === "orderedNestedList" || e === "unorderedNestedList";
	}
	get marks() {
		let t = {};
		return this.config.allowedInline.forEach((n) => {
			e[n] && (t[n] = e[n]);
		}), t;
	}
};
//#endregion
export { r as SchemaGenerator };
